const TWEEN = require('@tweenjs/tween.js');

export const defaultDuration = 250;

export const calculateDuration = (direction, defaultDuration, propsDuration) => {
  let dur = defaultDuration;
  if (propsDuration !== undefined) {
    if (typeof propsDuration === 'object') {
      if (propsDuration[direction] !== undefined) dur = propsDuration[direction];
      else dur = defaultDuration;
    } else {
      dur = propsDuration;
    }
  }
  return dur;
};

export const chainTween = (...tweens) => {
  return tweens.reduce((acc, n) => {
    if (acc === null) return n;
    acc.chain(n);
    return acc;
  }, null);
};

export const createTween = ({ start, end, duration }, onUpdate, onComplete) => {
  const tween = new TWEEN.Tween(start);
  tween
    .to(end, duration)
    .onUpdate(onUpdate)
    .onComplete(onComplete);
  return tween;
};

export const runAnimation = (tween) => {
  function animate(time) {
    requestAnimationFrame(animate);
    TWEEN.update(time);
  }
  requestAnimationFrame(animate);

  tween.start();
};
